import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const EndDate: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="4"
        y="5"
        width="16"
        height="16"
        rx="3"
        stroke={color}
        strokeWidth="2"
      />
      <rect x="4" y="10" width="16" height="2" fill={color} />
      <rect x="7" y="2" width="2" height="6" rx="1" fill={color} />
      <rect x="15" y="2" width="2" height="6" rx="1" fill={color} />
      <path
        d="M13.4872 16.3898L17.1879 19.3503C17.5153 19.6122 18 19.3789 18 18.9597L18 13.0403C18 12.6211 17.5153 12.3878 17.1879 12.6497L13.4872 15.6102C13.237 15.8104 13.237 16.1896 13.4872 16.3898Z"
        fill={color}
      />
      <path
        d="M23 17C23.5523 17 24 16.5523 24 16C24 15.4477 23.5523 15 23 15L23 17ZM18 17L23 17L23 15L18 15L18 17Z"
        fill={color}
      />
    </svg>
  );
};

export default EndDate;
